import actions from '../../actionTypes';

export default data => {
  return {
    type: actions.BULK_UPLOAD_CLEAR
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/bulkUploadClear.js